import { c as _c } from "react/compiler-runtime";
import { FunnelTypeDescriptionEnum, FunnelTypeTitleEnum } from 'modules/funnels/enums/funnel-type-enum';
import { FunnelCreateInterface } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import { FieldErrorAndDescription, FieldErrorAndDescriptionProps } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { FunnelIcon, SocialCommunityIcon, StoreIcon, SupportIcon } from '@systemeio/ui/icons';
interface FunnelGoalSelectorProps extends FieldErrorAndDescriptionProps {
  value: FunnelCreateInterface['type'];
  onChange: (value: FunnelCreateInterface['type']) => void;
}
const FunnelGoalSelector = t0 => {
  const $ = _c(18);
  const {
    value,
    onChange,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.choose_funnel_goal");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span>{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-danger">*</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="flex gap-0.5">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Object.keys(FunnelTypeTitleEnum);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange || $[9] !== t || $[10] !== value) {
    t6 = <ul className="flex flex-col flex-wrap gap-3 lg:flex-row">{t5.map(el => {
        const key = el as keyof typeof FunnelTypeTitleEnum;
        const isSelected = value === key;
        return <li key={key}><button onClick={e => {
            e.preventDefault();
            onChange(key);
          }} className={`h-full w-full items-start rounded-lg border lg:w-[290px] ${isSelected ? "border-brand-primary" : "border-text-secondary/50"} focus-visible:border-brand-primary main-transition-colors hover:border-brand-primary flex flex-col gap-1 px-4 py-4 outline-hidden`} data-test={`funnel-goal-${key}`}>{key === "optin" && <SocialCommunityIcon className={`${isSelected && "fill-brand-primary"} main-transition-colors h-[30px]`} />}{key === "sales" && <StoreIcon className={`${isSelected && "fill-brand-primary main-transition-colors"} h-[30px]`} />}{key === "custom" && <FunnelIcon className={`${isSelected && "fill-brand-primary main-transition-colors"} h-[30px]`} />}{key === "webinar" && <SupportIcon className={`${isSelected && "fill-brand-primary main-transition-colors"} h-[30px]`} />}<span className="text-text-primary text-start font-bold">{t(FunnelTypeTitleEnum[key])}</span><span className="text-start">{t(FunnelTypeDescriptionEnum[key])}</span></button></li>;
      })}</ul>;
    $[8] = onChange;
    $[9] = t;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== error) {
    t7 = <FieldErrorAndDescription error={error} />;
    $[12] = error;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-1" data-test="funnel-goal-selector">{t4}{t6}{t7}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default FunnelGoalSelector;